import { render, staticRenderFns } from "./ReservationsMedias.vue?vue&type=template&id=38ed1880&"
import script from "./ReservationsMedias.vue?vue&type=script&lang=js&"
export * from "./ReservationsMedias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports